import { render, staticRenderFns } from "./yxCategorySelectSecond.vue?vue&type=template&id=b1400b00&scoped=true"
import script from "./yxCategorySelectSecond.vue?vue&type=script&lang=js"
export * from "./yxCategorySelectSecond.vue?vue&type=script&lang=js"
import style0 from "./yxCategorySelectSecond.vue?vue&type=style&index=0&id=b1400b00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1400b00",
  null
  
)

export default component.exports